module.exports = __webpack_public_path__ + "static/media/temperature_high.a09e6752.svg";